import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

const UnitMetricsTooltip = () => (
    <Tooltip
        arrow={{ pointAtCenter: true }}
        color='var(--bgSection)'
        styles={{ root: { maxWidth: 600 } }}
        title={
            <div className='whitespace-nowrap px-[8px] py-[8px] !text-[var(--colorSub)] [&_*]:!text-[var(--colorSub)] text-[15px]'>
                <div className='mb-[15px] font-[600] uppercase text-[12px]'>
                    Lice reduction, mortality increase at unit level
                </div>
                <div className='mb-[15px]'>
                    The metrics represent lice reduction and mortality increase on the fish at unit level.
                </div>
                <div>Specify by corresponding formula:</div>
                <div>(Lice at unit 2 weeks before - 2 weeks after) / 2 weeks before * 100%</div>
                <div>(Mortality at unit 2 weeks after - 2 weeks before) / 2 weeks after * 100%</div>
                <div className='mt-[15px] italic'>
                    (If the fish are transferred after treatment, the system will use data at the new unit.)
                </div>
            </div>
        }
    >
        <InfoCircleOutlined className='cursor-help text-[18px] text-[var(--colorSub)]' />
    </Tooltip>
);

export default UnitMetricsTooltip;
